var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.8 15.3C7.61667 15.1167 7.52067 14.8834 7.512 14.6C7.504 14.3167 7.59167 14.0834 7.775 13.9L12.675 9.00005H1.5C1.21667 9.00005 0.979 8.90405 0.787 8.71205C0.595667 8.52071 0.5 8.28338 0.5 8.00005C0.5 7.71672 0.595667 7.47905 0.787 7.28705C0.979 7.09572 1.21667 7.00005 1.5 7.00005H12.675L7.775 2.10005C7.59167 1.91672 7.504 1.68338 7.512 1.40005C7.52067 1.11672 7.61667 0.883382 7.8 0.700048C7.98333 0.516715 8.21667 0.425049 8.5 0.425049C8.78333 0.425049 9.01667 0.516715 9.2 0.700048L15.8 7.30005C15.9 7.38338 15.971 7.48738 16.013 7.61205C16.0543 7.73738 16.075 7.86672 16.075 8.00005C16.075 8.13338 16.0543 8.25838 16.013 8.37505C15.971 8.49172 15.9 8.60005 15.8 8.70005L9.2 15.3C9.01667 15.4834 8.78333 15.575 8.5 15.575C8.21667 15.575 7.98333 15.4834 7.8 15.3Z",
    fill: "url(#paint0_linear_1105_1716)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1105_1716",
    x1: 0.5,
    y1: 10.3807,
    x2: 16.075,
    y2: 10.3807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E64C51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E32970"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowForward);
export default __webpack_public_path__ + "static/media/arrow_forward.fb139204bb0a082d8600beb41b6a8e9f.svg";
export { ForwardRef as ReactComponent };